import { MODULES } from "@core/constants/modules.contants";
import { useService } from "@policoders/di";
import Layout from "@shared/components/layout.component";
import { NavbarItem } from "@shared/components/navbar/navbar-item.model";
import NavbarService from "@shared/components/navbar/navbar.service";
import { Outlet } from "react-router-dom";

export const AdministrationLayout: React.FC = () => {
  const items: NavbarItem[] = [
    { label: "Início", to: "/administration", type: "nav-item" },
    { label: "Usuários", to: "/administration/users", type: "nav-item" },
    { label: "Empresas", to: "/administration/companies", type: "nav-item" },
  ];
  const navbar = useService<NavbarService>("NavbarService");
  navbar.set({ module: MODULES.ADMINISTRATION, navbar: items });
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};
